import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router";
import "@fontsource-variable/manrope";
import "@fontsource-variable/jetbrains-mono";
import "./prototype.css";
import { applyTheme, loadTheme } from "./theme";
import { AppShell } from "./components/AppShell";
import { Login } from "./pages/Login";
import { AdminQueue, MyTickets } from "./pages/Lists";
import { IncidentDetail } from "./pages/IncidentDetail";
import { IncidentList } from "./pages/IncidentList";
import { IncidentForm } from "./pages/IncidentForm";
import { IncidentResponders } from "./pages/IncidentResponders";
import { AdminLists } from "./pages/AdminLists";
import { AdminUsers } from "./pages/AdminUsers";
import { AllTickets } from "./pages/AllTickets";
import { Reports } from "./pages/reports/Reports";
import { SubmissionDetail } from "./pages/SubmissionDetail";
import { SubmissionForm } from "./pages/SubmissionForm";

// Every visit to the page gets its own location key, so clicking "Raise an engineering ticket" again (even while on the form) remounts it empty.
function NewIssue() {
  return <SubmissionForm key={useLocation().key} />;
}

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } });

// Before the first paint, so a saved Light or Dark choice does not flash the other theme.
applyTheme(loadTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<AppShell />}>
            <Route path="/new/eng" element={<NewIssue />} />
            <Route path="/submissions/:id" element={<SubmissionDetail />} />
            <Route path="/new/incident" element={<IncidentForm />} />
            <Route path="/incidents" element={<IncidentList />} />
            <Route path="/incidents/:id" element={<IncidentDetail />} />
            <Route path="/admin/responders" element={<IncidentResponders />} />
            <Route path="/admin/lists" element={<AdminLists />} />
            <Route path="/admin/admins" element={<AdminUsers />} />
            <Route path="/mine" element={<MyTickets />} />
            <Route path="/tickets" element={<AllTickets />} />
            <Route path="/reports" element={<Navigate to="/reports/headline" replace />} />
            <Route path="/reports/:tab" element={<Reports />} />
            <Route path="/admin" element={<AdminQueue />} />
            <Route path="*" element={<Navigate to="/new/eng" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
